@defer {
  <div class="container">
    <dn-top-header />
    <dn-sticky-notification />
    <div class="router-container" [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''">
      <router-outlet #o="outlet" class="main-outlet" />
    </div>
  </div>

  <dn-mobile-block />
}
